<template>
    <main :class="displayClass + ' pt-4'">
        <other-history-list></other-history-list>
        <div class=" mb-5">
            <nav aria-label="Page navigation example">
                <ul class="pagination">
                    <li class="page-item"><a class="page-link" href="#">Previous</a></li>
                    <li class="page-item"><a class="page-link" href="#">1</a></li>
                    <li class="page-item"><a class="page-link" href="#">2</a></li>
                    <li class="page-item"><a class="page-link" href="#">3</a></li>
                    <li class="page-item"><a class="page-link" href="#">Next</a></li>
                </ul>
            </nav>
        </div>
    </main>
</template>

<script>
import otherHistoryList from '../Other/ListHistoryView.vue'

export default {
    name: 'BsDashBoardView',
    data: function () {
        return {
            'tab_active': 'drive',//or th ead
        }
    },
    props: {
        displayClass: {
            type: String,
            default: 'col-md-9 ms-sm-auto col-lg-10 px-md-4'
        },
    },
    components: {
        otherHistoryList,
    },
    methods: {
        tab_switch_action(tab) {
        this.tab_active = tab;
        },
    },
    computed: {
        tabDisplay: function () {
        const self_tab_active = this.tab_active;
        return function (tab) {
            let tabClass = 'd-none ';
            if(self_tab_active == tab){
            tabClass = 'd-block';
            }
            return tabClass;
        }

        },
        tab_switch: function() {
        const self_tab_active = this.tab_active;
        return function (tab) {
            let tabClass = 'nav-link ';
            console.log('tab_switch', self_tab_active);
            if(self_tab_active == tab){
            tabClass += 'active';
            }
            return tabClass;
        }
        },
    }
}
</script>
